import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import {titleTemplate} from 'utils/seoUtils';


const helmetProps = {
  titleTemplate: titleTemplate.greyhoundRacing
}

export default function GreyhoundRacingBase({children}) {
  return (
    <div className="greyhound-racing-content">
      <MetaDataWrapper helmetProps={helmetProps} />
      {children}
    </div>
  );
}

GreyhoundRacingBase.propTypes = {
  children: PropTypes.any
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingBase.js